<mat-form-field class="form-element" appearance="fill">
  <mat-label>enclosure class @if (fieldName) { [{{ fieldName }}] }</mat-label>
  <mat-select (selectionChange)="encClassChangeAction($event)" placeholder="enclosure class" [formControl]="selectListControl">
    <mat-option value="empty"></mat-option>
    @for (encClass of encClassList; track encClass) {
      <mat-option [value]="encClass.name" >{{ encClass.name }}</mat-option>
    }
    <mat-option value="create">Add new enclosure class</mat-option>
  </mat-select>
</mat-form-field>
